module.exports = __webpack_public_path__ + "img/games-5.d2acb49e.webp";